module.exports = __webpack_public_path__ + "img/independent-writer.a5688282.svg";